module.exports = __webpack_public_path__ + "fonts/Akkurat.cf332702.ttf";